import { useMemo } from 'react';
import gql from 'graphql-tag';
import get from 'lodash/get';
import useConfig from 'UI/customHooks/useConfig';
import { useQuery } from '@apollo/client';

export const TIMELINE_PERSON_MEASURE_FRAGMENT = gql`
  fragment timelinePersonMeasureFragment on PersonMeasure {
    type
    status
    title
    startedAt
    endedAt
    notes
    documentUrl
    discussionPartner {
      _id
      profile {
        name
      }
    }
    skills {
      _id
      synonym(policiesPreset: $policiesPreset) {
        _id
        synonymId
        synonymLang
        synonymString
        companySpecific {
          _id
          isLogoVisible
        }
      }
    }
    metadata {
      contactEmail
      url
      description
      courseUrl {
        url
        isEditable
      }
      courseId
      capabilityUrl
      capabilityId
      customUrl
      certificateType
      timeSpent
    }
  }
`;

export const GET_PERSONAL_DEVELOPMENT_TIMELINE_DATA = gql`
  query GET_PERSONAL_DEVELOPMENT_TIMELINE_DATA(
    $filter: PersonMeasuresFilterInput
    $targetUserId: String
    $policiesPreset: PoliciesPresetInput
  ) {
    getPersonMeasures(filter: $filter, targetUserId: $targetUserId) {
      id
      ...timelinePersonMeasureFragment
    }
  }
  ${TIMELINE_PERSON_MEASURE_FRAGMENT}
`;

export const usePersonMeasures = queryVariables => {
  const config = useConfig();
  const hasPersonalDevelopmentFeature = get(config, 'cms.features.personalDevelopment.isEnabled');

  const { data, loading: isLoading } = useQuery(GET_PERSONAL_DEVELOPMENT_TIMELINE_DATA, {
    variables: queryVariables,
    skip: !hasPersonalDevelopmentFeature,
  });

  const personMeasures = useMemo(() => (data && data.getPersonMeasures) || [], [data]);

  return {
    isLoading,
    personMeasures,
  };
};
